import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { AiConfigurationSection, AiFormActions, AiGeneralSection } from './sections';
import styles from './ai-settings-form.css';
export function AiSettingsForm(props) {
    const { form, className, onFormSave, onFormCancel } = props;
    return (_jsx("div", { className: classNames(styles.formContainer, className), children: _jsxs("div", { className: styles.mainContent, children: [_jsx(AiGeneralSection, { className: styles.section, form: form }), _jsx(AiConfigurationSection, { className: styles.section, form: form }), _jsx(AiFormActions, { className: styles.section, onFormSave: onFormSave, form: form, onFormCancel: onFormCancel })] }) }));
}
